const PendingIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.11816 0C3.69884 0 0.118164 3.5831 0.118164 8C0.118164 12.4169 3.70127 16 8.11816 16C12.5375 16 16.1182 12.4169 16.1182 8C16.1182 3.5831 12.5351 0 8.11816 0ZM8.11816 14.2255C4.68577 14.2255 1.89513 11.4348 1.89513 8.00243C1.89513 4.57004 4.68577 1.7794 8.11816 1.7794C11.5506 1.7794 14.3412 4.57004 14.3412 8.00243C14.3412 11.4348 11.5481 14.2255 8.11816 14.2255Z" fill="#FAAD54" />
    <path d="M9.01158 4.44141H7.23218V8.36483L10.1614 11.294L11.4181 10.0373L9.01158 7.63071V4.44141Z" fill="#FAAD54" />
  </svg>
);

export default PendingIcon;
